module.exports = __webpack_public_path__ + "img/background.967fe008.png";